import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
    selector: 'prev-icon',
    templateUrl: './prev-icon.component.html',
    styleUrl: './prev-icon.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class PrevIconComponent {}
